import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import api, { homePathForRole } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Zap } from "lucide-react";

const AuthCallback = () => {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash;
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? match[1] : null;

    const run = async () => {
      if (!sessionId) {
        navigate("/", { replace: true });
        return;
      }
      try {
        const res = await api.post("/auth/session", null, { headers: { "X-Session-ID": sessionId } });
        setUser(res.data);
        window.history.replaceState(null, "", window.location.pathname);
        navigate(homePathForRole(res.data.role), { replace: true });
      } catch (e) {
        navigate("/", { replace: true });
      }
    };
    run();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen bg-ink-900 flex items-center justify-center">
      <div className="flex flex-col items-center gap-4">
        <div className="w-12 h-12 rounded-xl bg-brand flex items-center justify-center animate-pulse">
          <Zap className="w-7 h-7 text-ink-900" fill="#09090B" />
        </div>
        <p className="text-zinc-400">Signing you in…</p>
      </div>
    </div>
  );
};

export default AuthCallback;
